(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.RightBridge",
            {
                url: "/RightBridge",
                component: "rightbridge",
                PageTitle: "RightBridge",
                requiredPermissions: "RightBridge:Access",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("rightbridge",
    {
        templateUrl: "App/Resources/RightBridge/RightBridge.html",
        controller: biCtrl,
        bindings: {
            states: "<"
        }
    });

    biCtrl.$inject = ["ssoApi", "eligibilityFormApi", "eligibilityFormDialog", "surveys", "permissionService", "externalLoading"];
    function biCtrl(ssoApi, eligibilityFormApi, eligibilityFormDialog, surveys, permissionService, externalLoading) {
        var $ctrl = this;
              
        this.activateRightBridgeSso = function () {
            if (permissionService.hasOnePermission("RightBridge:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateRightBridgeSso().then(function(data) {
                        //console.log(data);
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                    },
                    function(error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };
    }
})(window.app, window.angular); // jshint ignore:line